import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { cn } from "./../../lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap hover:cursor-pointer hover:pointer-events-auto rounded-md text-sm font-normal ring-offset-background transition-colors focus-visible:outline-none  disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90 ",
        destructive:
          "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "border-2  text-primary !bg-background",
        primary:
          "px-10 bg-blueish text-white py-[10px] rounded-md font-geomanistMedium leading-[23px] text-[18px] hover:cursor-pointer",
        secondary:
          "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-10 w-[100%] px-3 py-2.5 ",
        sm: "h-9 rounded-md px-3",
        md: "rounded h-10 px-5",
        lg: "h-11 rounded-xl px-5 py-2.5",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

const Button = React.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    );
  }
);
Button.displayName = "Button";

export { Button, buttonVariants };
